<!-- <div mat-dialog-title style="display: flex; flex-direction: column; align-items: center;">
  <h1 class="title">{{data.member.name}}</h1>
  
</div>

<div mat-dialog-content style="display: flex; justify-content: center; align-items: stretch; overflow: hidden;"
  class="test">
  <div class="test" style="height: 50vh; width: 100%; display: flex; justify-content: center;">
    <img [src]="data.member.img" height='100%' width='auto'>
  </div>
</div>
<div mat-dialog-actions style="display: flex; justify-content: center;">
  <button mat-dialog-close>Close</button>
</div> -->

<!-- TAKE TWO -->
<div class="container" [ngStyle]="{'background-image': 'url('+data.img+')'}">
  <h1 class="title">{{data.title}}</h1>
  <h3 style="margin: 0; text-align: center; text-shadow: 1px 1px 1px black;">{{data.subtitle}}</h3>
</div>


<!-- <div class="container">
  <img [src]="data.member.img">
  <h3 style="margin: 0; text-align: center; text-shadow: 1px 1px 1px black;">{{data.member.position}}</h3>
  <h1 class="title">{{data.member.name}}</h1>
</div> -->

<div mat-dialog-actions style="display: flex; justify-content: center;">
  <button mat-dialog-close>Close</button>
</div>
<!--  -->
